import {Dayjs} from 'dayjs';
import {DateRange} from '@mui/lab';
import {Add} from '@mui/icons-material';
import {useCallback, useState} from 'react';
import {IconButton, ListItem} from '@mui/material';
import {DateRangePicker} from '@mui/x-date-pickers-pro';
import {iTimedMsgDateRange} from './TimedMsgRequestDateRangePicker';

const TimedMsgDateRange = ({
  onChangeDates,
}: {
  onChangeDates: (value: React.SetStateAction<iTimedMsgDateRange[]>) => void;
}) => {
  const [dates, setDates] = useState<DateRange<Dayjs | null>>([null, null]);

  const handleOnChange = useCallback((dates: DateRange<Dayjs | null>) => {
    setDates(dates);
  }, []);

  const handleAdd = () => {
    onChangeDates(prevDateRanges => {
      if (!prevDateRanges[0]?.start_date && !prevDateRanges[0]?.end_date) {
        return [{id: Date.now(), start_date: dates[0], end_date: dates[1]}];
      }
      return [
        ...prevDateRanges,
        {id: Date.now(), start_date: dates[0], end_date: dates[1]},
      ];
    });
    setDates([null, null]);
  };

  return (
    <ListItem disableGutters>
      <DateRangePicker
        className='max-w-320'
        disablePast
        localeText={{start: 'Start Date', end: 'End Date'}}
        value={dates}
        onChange={handleOnChange}
      />

      <IconButton
        className='ml-4 w-40 h-40 font-bold radius-5'
        sx={{
          background: `var(--blue-variant10)`,
          border: `1px solid var(--blue_variant40)`,
        }}
        aria-label='add-time'
        onClick={handleAdd}>
        <Add />
      </IconButton>
    </ListItem>
  );
};

export default TimedMsgDateRange;
